import ogImage from "../../public/images/header-bg.png";
import { CANONICAL_URL } from "./constant";
import { getDynamicURL } from "./helper-funcations";

interface MetaService {
  title: string;
  description: string;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  ogImg?: string | null;
  ogWidth?: string;
  ogHeight?: string;
  canonicalLink: string;
  hreflangs?: { hrefLang: string; href: string }[];
}

export const metaService = ({
  title,
  description,
  ogTitle,
  ogDescription,
  ogUrl,
  ogImg,
  ogWidth = "1200",
  ogHeight = "630",
  canonicalLink,
  hreflangs = [],
}: MetaService) => {
  const URL = getDynamicURL();

  return [
    { title }, // Just use the title directly
    {
      name: "description",
      content: description, // No need to wrap in an object
    },
    {
      property: "og:title",
      content: ogTitle, // Use the string directly
    },
    {
      property: "og:description",
      content: ogDescription, // Use the string directly
    },
    {
      property: "og:url",
      content: `${URL}${ogUrl}`,
    },
    {
      property: "og:image",
      content: ogImg ? ogImg : ogImage,
    },
    {
      property: "og:width",
      content: ogWidth,
    },
    {
      property: "og:height",
      content: ogHeight,
    },
    {
      tagName: "link",
      rel: "canonical",
      href: `${CANONICAL_URL}${canonicalLink}`,
    },
    ...hreflangs.map(({ hrefLang, href }) => ({
      tagName: "link",
      rel: "alternate",
      hrefLang,
      href: `${URL}${href}`,
    })),
  ];
};
